import * as tslib_1 from "tslib";
import { ComponentFactory, Inject, Injectable, Injector, Type } from '@angular/core';
import { DYNAMIC_COMPONENT, PLACEHOLDER_COMPONENTS, PLACEHOLDER_LAZY_COMPONENTS } from './components/placeholder.token';
import { RawComponent } from './components/raw.component';
import { isRawRendering } from './components/rendering';
import * as ɵngcc0 from '@angular/core';
let JssComponentFactoryService = class JssComponentFactoryService {
    constructor(injector, components, lazyComponents) {
        this.injector = injector;
        this.components = components;
        this.lazyComponents = lazyComponents;
        this.componentMap = new Map();
        this.lazyComponentMap = new Map();
        this.components.forEach((c) => this.componentMap.set(c.name, c.type));
        if (this.lazyComponents) {
            this.lazyComponents.forEach((c) => this.lazyComponentMap.set(c.path, c));
        }
    }
    getComponent(component) {
        const loadedComponent = this.componentMap.get(component.componentName);
        if (loadedComponent) {
            return Promise.resolve({
                componentDefinition: component,
                componentImplementation: this.componentMap.get(component.componentName),
            });
        }
        const lazyComponent = this.lazyComponentMap.get(component.componentName);
        if (lazyComponent) {
            return lazyComponent.loadChildren()
                .then((ngModuleFactory) => {
                let componentType = null;
                const moduleRef = ngModuleFactory.create(this.injector);
                const dynamicComponentType = moduleRef.injector.get(DYNAMIC_COMPONENT);
                if (!dynamicComponentType) {
                    throw new Error(
                    // tslint:disable-next-line:max-line-length
                    `JssComponentFactoryService: Lazy load module for component "${lazyComponent.path}" missing DYNAMIC_COMPONENT provider. Missing JssModule.forChild()?`);
                }
                if (component.componentName in dynamicComponentType) {
                    componentType = dynamicComponentType[component.componentName];
                }
                else {
                    if (typeof dynamicComponentType === 'function') {
                        componentType = dynamicComponentType;
                    }
                    else {
                        throw new Error(
                        // tslint:disable-next-line:max-line-length
                        `JssComponentFactoryService: Lazy load module for component "${lazyComponent.path}" missing DYNAMIC_COMPONENT provider. Missing JssModule.forChild()?`);
                    }
                }
                return {
                    componentDefinition: component,
                    componentImplementation: componentType,
                    componentFactory: moduleRef.componentFactoryResolver.resolveComponentFactory(componentType),
                };
            });
        }
        return Promise.resolve({
            componentDefinition: component,
        });
    }
    getComponents(components) {
        // acquire all components and keep them in order while handling their potential async-ness
        return Promise.all(components.map((component) => isRawRendering(component)
            ? this.getRawComponent(component)
            : this.getComponent(component)));
    }
    getRawComponent(component) {
        return Promise.resolve({
            componentImplementation: RawComponent,
            componentDefinition: component,
        });
    }
};
JssComponentFactoryService.ɵfac = function JssComponentFactoryService_Factory(t) { return new (t || JssComponentFactoryService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(PLACEHOLDER_COMPONENTS), ɵngcc0.ɵɵinject(PLACEHOLDER_LAZY_COMPONENTS)); };
JssComponentFactoryService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: JssComponentFactoryService, factory: function (t) { return JssComponentFactoryService.ɵfac(t); } });
JssComponentFactoryService.ctorParameters = () => [
    { type: Injector },
    { type: Array, decorators: [{ type: Inject, args: [PLACEHOLDER_COMPONENTS,] }] },
    { type: Array, decorators: [{ type: Inject, args: [PLACEHOLDER_LAZY_COMPONENTS,] }] }
];
JssComponentFactoryService = tslib_1.__decorate([ tslib_1.__param(1, Inject(PLACEHOLDER_COMPONENTS)),
    tslib_1.__param(2, Inject(PLACEHOLDER_LAZY_COMPONENTS))
], JssComponentFactoryService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JssComponentFactoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Inject,
                args: [PLACEHOLDER_COMPONENTS]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [PLACEHOLDER_LAZY_COMPONENTS]
            }] }]; }, null); })();
export { JssComponentFactoryService };
